module.exports = __webpack_public_path__ + "img/28_33.e7187f9c.png";